import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilter',
  pure: false
})
export class SearchFilterPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(args.Field==undefined ||args.Field===null|| args.Field==="")
    {
      if(!value)return null;
      if(!args)return value;
      args = args.toLowerCase();
      return value.filter(function(data){
          return JSON.stringify(data).toLowerCase().includes(args);
      });
    }
    else{
      if(!value)return null;
      if(!args)return value;
      let val = args.Value.toLowerCase();
      return value.filter(function(data:any){
          return JSON.stringify(data[args.Field]).toLowerCase().includes(val);
      });
    }
    
}

}
